export enum PromotionTypeEnum {
  SPECIAL_PRICE = 'SPECIAL_PRICE',
  BUY_X_GET_ONE_FREE = 'BUY_X_GET_ONE_FREE',
  BUY_X_CHEAPER = 'BUY_X_CHEAPER',
  PAIR_SAVER = 'PAIR_SAVER',
  BUY_TWO_PAY_ONE = 'BUY_TWO_PAY_ONE',
  TIER = 'TIER'
}

export enum PromotionPageModeEnum {
  REQUEST_CREATE = 'REQUEST_CREATE',
  REQUEST_VIEW = 'REQUEST_VIEW',
  REQUEST_EDIT = 'REQUEST_EDIT',
  VIEW = 'VIEW'
}

export enum DiscountTypeEnum {
  VALUE = 'VALUE',
  PERCENT = 'PERCENT',
  DISCOUNT_AMOUNT = 'DISCOUNT_AMOUNT'
}

export enum PromotionStatusEnum {
  A = 'APPROVED',
  C = 'CANCELLED',
  D = 'DRAFT',
  R = 'REJECTED',
  W = 'AWAITING_APPROVAL',
  AWAITING_APPROVAL = 'W',
  REJECTED = 'R',
  DRAFT = 'D',
  CANCELLED = 'C',
  APPROVED = 'A',
  AWAITING_SCHEDULE = 'AWAITING_SCHEDULE',
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED'
}

export const promotionConditionConfig = {
  SPECIAL_PRICE: { forceBuyQtyFrom: { start: 1, end: 1 }, freeQTY: null, discountType: [DiscountTypeEnum.VALUE] },
  BUY_X_GET_ONE_FREE: { forceBuyQtyFrom: { start: 1, end: 12 }, freeQTY: 1, discountType: [DiscountTypeEnum.VALUE] },
  BUY_X_CHEAPER: {
    forceBuyQtyFrom: { start: 2, end: 12 },
    freeQTY: null,
    discountType: [DiscountTypeEnum.VALUE, DiscountTypeEnum.PERCENT]
  },
  PAIR_SAVER: {
    forceBuyQtyFrom: { start: 2, end: 2 },
    freeQTY: null,
    discountType: [DiscountTypeEnum.VALUE, DiscountTypeEnum.PERCENT, DiscountTypeEnum.DISCOUNT_AMOUNT]
  },
  BUY_TWO_PAY_ONE: {
    forceBuyQtyFrom: { start: 2, end: 2 },
    freeQTY: 1,
    discountType: [DiscountTypeEnum.VALUE]
  },
  TIER: {
    forceBuyQtyFrom: { start: 'Tier', end: 'Tier' },
    freeQTY: null,
    discountType: [DiscountTypeEnum.VALUE, DiscountTypeEnum.PERCENT]
  }
};

export enum PromotionGroupNameEnum {
  A = 'A',
  B = 'B'
}

export enum SelectedPromotionStoreEnum {
  ALL_STORE = 'ALL_STORE',
  SELECT_BY_STORE = 'SELECT_BY_STORE'
}

export enum PromotionSpecificConditionEnum {
  DAY_OF_THE_WEEK = 'DAY_OF_THE_WEEK',
  EVERYDAY = 'EVERYDAY'
}

export type ForceBuyQtyRange = { start: number; end: number } | { start: string; end: string };
